import { useEffect, useState } from "react"
import InvoicesStarter from "../components/InvoicesStarter"
import axios from "axios"
import api from "../config/backend"
import { toast } from "react-toastify"
import "./css/Invoices.css"
import InvoicesList from "../components/InvoicesList"
import { SpinnerCircular } from "spinners-react"
import CreateCustomer from "./CreateCustomer"
import CustomersList from "../components/CustomersList"
import CustomersStarter from "../components/CustomersStarter"

const Customers = () => {
    const [createCustomer, setCreateCustomer] = useState(false)
    const [customersList, setCustomersList] = useState([])
    const [customerListRefresh, setCustomerListRefresh] = useState(0)
    const [loading, setLoading] = useState(true)

    const token = localStorage.getItem("_crm__token")

    const fetchCustomers = async () => {
        const { data, status } = await axios.post(`${api}/Accounting/fetch-customers`, { token })

        setLoading(false)

        if (data.success) {
            setCustomersList(data.customers)
        }
        else {
            toast.error(data.message)
        }
    }

    useEffect(() => {
        fetchCustomers()
    }, [customerListRefresh])

    if (createCustomer) {
        return <CreateCustomer setCreateCustomer={setCreateCustomer} setCustomerListRefresh={setCustomerListRefresh} />
    }

    if (loading) {
        return (
            <div className="_5dut">
                <SpinnerCircular size="60" color="#3b70ad" />
            </div>
        )
    }

    if (customersList.length) {
        return (
            <CustomersList customersList={customersList} setCreateCustomer={setCreateCustomer} />
        )
    }

    // New user - no invoices created
    return (
        <CustomersStarter setCreateCustomer={setCreateCustomer} />
    )
}

export default Customers

